import { getCurrentSpaceId } from "src/state/session/ssm";
import { CastedScreensCountDocument } from "src/types.g";

export const getRefetchScreenCountQuery = () => {
  return {
    query: CastedScreensCountDocument,
    variables: { spaceId: getCurrentSpaceId() },
  };
};
